export class InputMasks {
    public static readonly PhoneNumberMask: string = "(000) 000-0000 ext. 0000||(000) 000-0000 ext. 00||(000) 000-0000";
    public static readonly PhoneNumberMaskSpecialCharacters: string[]  = ['e', 'x', 't', ' ', '(', ')', '-', '.'];
    public static readonly PostalCodeMask: string = "S0S 0S0";

    public static readonly ReferenceNumberMask: string = "000 000 000";
    public static readonly ReferenceNumberMaskSpecialCharacters: string[]  = [' '];
}